import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';

import { Observable, of, timer } from 'rxjs';
import { map } from 'rxjs/operators';

import { WindowRefService } from '../../../core/services/windowRef/window-ref.service';
import { modulePaths } from '../../constants/preload-module-paths';

@Injectable({
    providedIn: 'root',
})
export class CustomPreloadingStrategyService implements PreloadingStrategy {
    preload(route: Route, load: () => Observable<any>): Observable<any> {
        const loadRouteModule = (delay: number) => (delay > 0 ? timer(delay * 1000).pipe(map(() => load())) : load());
        if (route.data && route.data['preload']) {
            if (this.shouldPreload(route)) {
                const delay = route.data['loadAfterSeconds'] ? route.data['loadAfterSeconds'] : 0;
                return loadRouteModule(delay);
            }
        }
        return of(null);
    }
    constructor(protected windowRef: WindowRefService) {}
    shouldPreload(route: Route): boolean {
        const index = this.windowRef.document['location'].pathname.indexOf('sport/');
        if (index <= 0 && modulePaths.includes(route['path']!)) {
            return false;
        }
        const conn = this.windowRef.nativeWindow.navigator.connection;
        if (conn) {
            const { effectiveType } = conn;
            if (['slow-2g', '2g', 'slow-3g'].includes(effectiveType)) {
                return false;
            }
        }
        return true;
    }
}
